import React from "react";
import Add from "./Add";
import Edit from "./Edit";
import { TourPackageProvider } from "../../../context/TourPackageContext";
import Overview from "./Overview";
export const TourPackage = () => {
  return (
    <TourPackageProvider>
      <Overview />
    </TourPackageProvider>
  );
};

export const AddTourPackage = () => {
  return (
    <TourPackageProvider>
      
        <Add />
      
    </TourPackageProvider>
  );
};

export const EditTourPackage = () => {
  return (
    <TourPackageProvider>
      
        <Edit />
      
    </TourPackageProvider>
  );
};
